// extracted by mini-css-extract-plugin
export default {"footer":"TeamsFooter_footer__VBL36"};